module.exports = __webpack_public_path__ + "static/gallery_wild_4_thumb-5c63600a35f82b07157e5ac569cc107f.jpg";